'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _beatle = require('beatle');

var _layerConvertor = require('./layerConvertor');

var _layerEditor = require('./layerEditor');

var _galleryResolver = require('./galleryResolver');

var _getCombox = require('./getCombox');

var _getComponent2 = require('../layouts/getComponent');

var _layouts = require('../layouts');

var _empty = require('antd/lib/empty');

var _empty2 = _interopRequireDefault(_empty);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Layer = exports.Layer = (_temp = _class = function () {
  function Layer(context, callback) {
    _classCallCheck(this, Layer);

    _initialiseProps.call(this);

    this.context = context;
    this._promise = new Promise(function (resolve) {
      Layer.resolveGallery(function (gallery) {
        gallery && (0, _galleryResolver.setGallery)(gallery);
        resolve(true);
        callback && callback();
      });
    });
    this._editable = false;
    this._activeFuns = [];
    this._watcherFns = [];

    this.state = {};
    // TODO Object to immutable
    this._state = Object(this.state);
  }

  _createClass(Layer, [{
    key: 'ready',
    value: function ready(callback) {
      this._promise.then(callback);
    }
  }, {
    key: 'setState',
    value: function setState(nextState) {
      var prevState = this.state;
      this.state = Object.assign({}, prevState, nextState);
      this._state = Object(this.state);

      this._watcherFns.forEach(function (fn) {
        fn.watcher(nextState, prevState);
      });
    }
  }, {
    key: 'watch',
    value: function watch(watcher, callback) {
      var name = typeof watcher === 'function' ? null : watcher;
      if (name) {
        watcher = function watcher(nextState, prevStore) {
          if (nextState[fnOpt.name] !== prevStore[fnOpt.name]) {
            fnOpt.resolve(nextState);
            fnOpt.resolved = false;
            fnOpt.promise = new Promise(function (resolve) {
              fnOpt.resolve = resolve;
            }).then(function (ret) {
              return fnOpt.callback && fnOpt.callback(ret);
            });
          }
        };
      }

      var fnOpt = this._watcherFns.find(function (fn) {
        return fn.name === name || fn.watch === watcher;
      });
      if (!fnOpt) {
        fnOpt = {
          name: name,
          watcher: watcher,
          callback: callback,
          resolved: true
        };
        this._watcherFns.push(fnOpt);
      }
      if (fnOpt.resolved) {
        fnOpt.resolved = false;
        fnOpt.promise = new Promise(function (resolve) {
          fnOpt.resolve = resolve;
        }).then(function (ret) {
          return fnOpt.callback && fnOpt.callback(ret);
        });
      }
      return fnOpt.promise;
    }
  }, {
    key: 'unwatch',
    value: function unwatch(watcher) {
      var idx = this._watcherFns.findIndex(function (fn) {
        return fn.name === watcher || fn.watch === watcher;
      });
      if (idx > -1) {
        this._watcherFns.splice(idx, 1);
      }
    }

    // -----------------------------

  }, {
    key: 'setEditable',
    value: function setEditable(editable) {
      this._editable = editable;
    }
  }, {
    key: 'isEditable',
    value: function isEditable() {
      return this._editable;
    }
  }, {
    key: 'register',
    value: function register(id, callback) {
      this._activeFuns.push({
        id: id,
        fn: callback,
        active: false
      });
    }
  }, {
    key: 'handleActive',
    value: function handleActive(id) {
      if (this._editable) {
        this._activeFns.forEach(function (afn) {
          afn.active = afn.id === id;
          afn.fn(afn.active);
        });
      }
    }
    // -----------------------------

  }, {
    key: 'getComponent',
    value: function getComponent(component, props, getProps) {
      if (component._async) {
        props = props || {};
      }
      var contextTypes = void 0;
      var newComponent = void 0;
      if (component.ChildComponent) {
        contextTypes = component.ChildComponent.contextTypes;
        component.ChildComponent = (0, _getComponent2.getComponent)(props, getProps)(component.ChildComponent);
        component.ChildComponent.contextTypes = contextTypes;

        newComponent = component;
      } else {
        contextTypes = component.contextTypes;
        newComponent = (0, _getComponent2.getComponent)(props, getProps)(component);
        newComponent.contextTypes = contextTypes;
      }
      return newComponent;
    }
    /**
     * com = {
     *  key,            // 组件key，可不填
     *  componentType,  // 组件源，默认不填是custom，分别为： antd、material、custom
     *  cname,          // 组件名，在组件源内唯一
     *  component,      // 组件定义
     *  getComponent,   // 动态组件，cname、component、getComponent选择其一
     *  view,           // 组件升级成view，可拥有model和services特性
     *  props,          // 组件props属性
     *  getProps        // 组件props动态属性,
     *  attrs,          // 组件放在容器中的定位
     * }
     */

  }, {
    key: 'parseComponent',
    value: function parseComponent(opt, staticProps) {
      /**
       * com = {
       *  componentType: [antd|custom|hc|material],
       *  cname: ['a', 'b'],
       *  props: {
       *    a: {
       *      ...
       *    },
       *    b: {
       *      componentType: [antd|custom|hc|material],
       *      component: 'x',
       *      ...
       *    }
       *  }
       * }
       */
      var newComponent = void 0;
      var props = opt.props;
      var getProps = _layerConvertor.converter.parse(opt.getProps);
      var cname = opt.cname;
      var componentOption = {
        static: opt.static,
        attrs: opt.attrs,
        key: opt.key || cname
      };
      if (opt.layer) {
        var layer = opt.layer;
        newComponent = (0, _galleryResolver.findComponent)(layer, true, 'layers');
        var layerProps = this.parseLayer(layer.components, layer.props, layer.grid, layer.item, staticProps);
        newComponent = this.toView(newComponent, layer.view, layerProps, getProps);
      } else {
        var view = opt.view;
        if (Array.isArray(cname)) {
          newComponent = (0, _getCombox.getCombox)(opt, _galleryResolver.findComponent, function () {
            return view ? newComponent.childContextTypes : newComponent.contextTypes;
          });
          props = view ? {} : null;
          getProps = null;
        } else {
          newComponent = (0, _galleryResolver.findComponent)(opt, true);
        }
        if (newComponent) {
          newComponent = this.toView(newComponent, view, props, getProps);
        } else {
          componentOption.props = props;
          componentOption.getProps = getProps;
        }
      }
      componentOption.component = newComponent;

      return componentOption;
    }
  }, {
    key: 'toView',
    value: function toView(component, viewOpt, props, getProps) {
      var newComponent = this.getComponent(component, props, getProps);
      if (viewOpt) {
        var providers = void 0;
        // const childContextTypes = {};
        if (viewOpt.providers) {
          providers = {};
          // 此处可能有问题
          (0, _forEach2.default)(viewOpt.providers, function (provider, name) {
            if (typeof name === 'number') {
              name = provider;
              provider = (0, _galleryResolver.findService)(name);
            }
            if (provider) {
              providers[name] = provider;
            }
            // childContextTypes[name] = PropTypes.object;
          });
        }
        if (viewOpt.selector) {
          var selector = new _beatle.BaseSelector();
          Object.assign(selector, viewOpt.selector);
          newComponent = this.context.app.view(selector, newComponent, providers, viewOpt.bindings, viewOpt.hookActions, viewOpt.props, viewOpt.getProps);
        } else {
          newComponent = this.context.app.view(newComponent, providers, viewOpt.bindings, viewOpt.hookActions, viewOpt.props, viewOpt.getProps);
        }
        // newComponent.childContextTypes = childContextTypes;
      }
      return newComponent;
    }

    /**
     * // 界面配置
     * sceneOption = {
     *  // 路由配置
     *  route: {
     *    title,
     *    path,
     *    value,
     *    disabled
     *  },
     *  // 布局设置
     *  layout: {
     *    cname,
     *    components: [],
     *    props: {
     *    }
     *  },
     *  // 面板设置
     *  layer: {
     *    cname: 'flexGridLayer',
     *    bindings: [String, ...],
     *    components: [
     *      {cname: String, props: Object, bindings: [], vector}
     *    ],
     *    props: {
     *    }
     *  }
     * }
     */

  }, {
    key: 'getLayer',
    value: function getLayer(opt, staticProps) {
      var _this = this;

      var promise = opt.then ? opt : Promise.resolve(opt);
      return Promise.all([promise, this._promise]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            opt = _ref2[0];

        return _this.getViewComponent(opt, staticProps);
      });
    }
  }, {
    key: 'getViewComponent',
    value: function getViewComponent(opt, staticProps) {
      var ViewComponent = this.parseComponent(opt, staticProps).component;
      // 默认加入app服务
      // LayerComponent.childContextTypes = LayerComponent.childContextTypes || {};
      // LayerComponent.childContextTypes.layer = PropTypes.object;

      if (opt.layout) {
        ViewComponent.routeOptions = this.parseRoute(opt.layout, ViewComponent.routeOptions);
      }
      return ViewComponent;
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(Layer, customLayouts) {
      /* eslint-disable */
      var viewComponent = _react2.default.createElement(Layer, null);
      if (Layer.routeOptions && Layer.routeOptions.layout) {
        return (0, _layouts.getLayout)({
          layoutOption: Layer.routeOptions.layoutOption,
          layout: Layer.routeOptions.layout
        }, viewComponent, customLayouts);
      } else {
        return viewComponent;
      }
    }
  }, {
    key: 'render',
    value: function render(opt, staticProps) {
      if (opt.then || opt.layer) {
        return this.context.app.observer(this.getLayer(opt, staticProps)).render(this.renderLayer);
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'o-spin-container' },
          _react2.default.createElement(_empty2.default, null)
        );
      }
    }
  }, {
    key: 'parseLayer',
    value: function parseLayer(components) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var layerGrid = arguments[2];

      var _this2 = this;

      var layerItem = arguments[3];
      var staticProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var layerProps = (0, _cloneDeep2.default)(props);
      // TODO LayerItem提供了拖拽功能
      layerProps.LayerGrid = layerGrid && (0, _galleryResolver.findComponent)(layerGrid) || _layerEditor.LayerGrid;
      layerProps.LayerItem = layerItem && (0, _galleryResolver.findComponent)(layerItem) || _layerEditor.LayerItem;
      layerProps.components = [];

      if (components) {
        (0, _forEach2.default)(components, function (com, key) {
          var extra = staticProps[key] || staticProps[com.key] || staticProps[com.cname];
          // 可能不太好！！
          if (extra) {
            if (extra.props) {
              if (com.props) {
                Object.assign(com.props, extra.props);
              } else {
                com.props = extra.props;
              }
            } else if (extra.getProps) {
              if (com.getProps) {
                var getProps = com.getProps;
                com.getProps = function (props, context) {
                  var _props = extra.getProps(props, context);
                  return Object.assign(_props, getProps(props, context));
                };
              } else {
                com.getProps = extra.getProps;
              }
            }
          }

          var newCom = _this2.parseComponent(com, extra && extra.staticProps);
          layerProps.components.push(newCom);
        });
      }
      return layerProps;
    }
  }, {
    key: 'parseRoute',
    value: function parseRoute(layout) {
      var _this3 = this;

      var routeOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var layouts = [];
      if (layout.containerLayout) {
        if (Object(layout.containerLayout) === layout.containerLayout) {
          layouts.push((0, _galleryResolver.findComponent)(layout.containerLayout, null, 'layouts'));
        } else {
          layouts.push(layout.containerLayout);
        }
      }
      layouts.push((0, _galleryResolver.findComponent)(layout, null, 'layouts'));

      routeOptions.layout = layouts;
      routeOptions.layoutOption = layout.option; // defaultsDeep({}, layout.option);
      if (routeOptions.layoutOption.components) {
        var newComponents = {};
        (0, _forEach2.default)(routeOptions.layoutOption.components, function (com, key) {
          if (typeof key === 'number') {
            key = com.key || com.cname;
          }
          newComponents[key] = _this3.parseComponent(com);
        });
        routeOptions.layoutOption.components = newComponents;
      }

      return routeOptions;
    }
  }, {
    key: 'createLayerRoutes',
    value: function createLayerRoutes(scenes) {
      var _this4 = this;

      var layerRoutes = [];
      (0, _forEach2.default)(scenes, function (sceneOption) {
        var route = Object.assign({}, sceneOption.route, {
          // sceneOption: sceneOption,
          getComponent: function getComponent(nextState, callback) {
            _this4.getLayer(sceneOption).then(function (component) {
              Object.assign(route, component.routeOptions);
              callback(null, component);
            }, callback);
          }
        });
        layerRoutes.push(route);
      });
      return layerRoutes;
    }
  }]);

  return Layer;
}(), _class.resolveGallery = function (callback) {
  return callback({});
}, _class.contextTypes = {
  app: _propTypes2.default.object
}, _initialiseProps = function _initialiseProps() {
  this.findComponent = _galleryResolver.findComponent;
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/layers/index.js
// module id = 46
// module chunks = 0